module.exports = __webpack_public_path__ + "img/tele2-mobile_fcd8b4797025ef31df7107833c6bf2b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/tele2-mobile.jpg
// module id = 255
// module chunks = 0